import React, { useState, } from 'react';
import { midas } from '@resurs/midas';
import { classNames } from '@resurs/hephaestus';
const RadioButtonGroup = ({ id, name, values, label, defaultCheckedValue, inline, styling, dataCy, onChange, children, }) => {
    const [internalValue, setInternalValue] = useState(defaultCheckedValue);
    const [, setValid] = useState(false);
    const [, setRequired] = useState(false);
    const handleInvalid = (event) => {
        event.preventDefault();
        setRequired(true);
    };
    const handleChange = (event) => {
        if (defaultCheckedValue) {
            setValid(true);
        }
        onChange === null || onChange === void 0 ? void 0 : onChange(event);
    };
    return (React.createElement("div", { id: id, className: midas.formGroup, "data-cy": dataCy },
        React.createElement("label", { className: midas.formLabel }, label),
        React.createElement("div", { style: { display: 'flex', flexWrap: 'wrap' } }, values.map((value) => (React.createElement("div", { key: value.key, style: styling },
            React.createElement("label", { className: classNames(midas.formRadio, inline && midas.inline, value.disabled && midas.disabled), htmlFor: id + value.key + value.value },
                React.createElement("input", { id: id + value.key + value.value, type: "radio", name: name || label, value: value.value, onClick: (event) => setInternalValue(event.currentTarget.value), defaultChecked: internalValue === value.value, disabled: value.disabled, onChange: handleChange, onInvalid: handleInvalid }),
                React.createElement("i", { className: midas.formIcon }),
                ' ',
                value.valueLabel ? value.valueLabel : value.value,
                children)))))));
};
export default RadioButtonGroup;
